var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330 32.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff7bac;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05D3\\u05E3_\\u05D4\\u05D1\\u05D9\\u05EA",
    "data-name": "\\u05D3\\u05E3 \\u05D4\\u05D1\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.62,11.73h-7.06v19.05H0v-7.72h4.64v-11.33H1.37v-7.72h28.18v26.77h-8.92V11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.91,4.02h8.92v14.72h-8.92V4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.87,30.79h-24.08v-7.72h11.24v-11.33h-11.24v-7.72h20.16v19.05h3.91v7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.84,11.73h-17.25v-7.72h26.17v26.77h-8.92V11.73ZM76.91,16.64h8.92v14.14h-8.92v-14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.56,4.02h8.92v14.72h-8.92V4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.74,4.02v26.77h-26.99v-7.72h4.73V4.02h8.92v19.05h4.42V4.02h8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.34,4.02h8.92v26.77h-8.92V4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.51,11.73h-12.61v-7.72h21.53v26.77h-8.92V11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.8,4.02h8.92v14.72h-8.92V4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.01,21.73v9.06h-8.92V2.9h.14l11.7,9.99,8.01-9.99,7.15,5.22-8.6,10.35,8.65,7.41-6.01,6.42-12.11-10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.08,15.3v15.53h-8.92v-15.35c0-2.41-1.87-4.33-4.28-4.33s-4.28,1.92-4.28,4.33v15.3h-8.92v-15.48c0-7.36,5.96-12.18,13.2-12.18s13.2,4.86,13.2,12.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.36,4.02h8.92v26.77h-8.92V4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.78,0h8.92v4.02h15.29l-11.79,27.66-8.15-3.26,7.19-16.69h-11.47V0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/לוח אירועי הביתmdpi.22d5992639caf20d29b5e866a76c99b0.svg";
export { ForwardRef as ReactComponent };